import { api } from '@/api';
import type {
  LoginRequestBody,
  LoginResponse,
  LogoutRequestBody,
} from '@/types/auth';
import type {
  CreateCustomerProfileRequestBodyDTO,
  CustomerProfileDetailsResponseDTO,
} from '@/types/dto/agent';
import axios from 'axios';

const BASE_URL = `${import.meta.env.VITE_APP_PROXY_TARGET}`;

export const authenticateUser = async (
  body: LoginRequestBody
): Promise<LoginResponse> => {
  const response = await axios.post(`${BASE_URL}/auth/token`, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
  return response.data;
};

export const registerUser = async (
  body: CreateCustomerProfileRequestBodyDTO
): Promise<CustomerProfileDetailsResponseDTO> => {
  const response = await axios.post(`${BASE_URL}/auth/register`, body);
  return response.data;
};

export const getCustomerProfile =
  async (): Promise<CustomerProfileDetailsResponseDTO> => {
    return (await api.agentApi.CustomerProfile_GetCustomerProfileDetails())
      .data;
  };

export const revokeToken = async (body: LogoutRequestBody): Promise<void> => {
  await axios.post(`${BASE_URL}/auth/revoke`, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};
